import { render, staticRenderFns } from "./FullScreenImageService.vue?vue&type=template&id=5ff99e29&scoped=true&"
import script from "./FullScreenImageService.vue?vue&type=script&lang=js&"
export * from "./FullScreenImageService.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenImageService.vue?vue&type=style&index=0&id=5ff99e29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff99e29",
  null
  
)

export default component.exports